(() => {
  if (window.__nbhMobileNavInitialized) return;
  window.__nbhMobileNavInitialized = true;

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.('.nbh-mobile-nav[open]') || document.querySelector('.nbh-mobile-nav[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nbh-mobile-nav[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
